export const permissionsClimate = [
  "climate",
  "everything-full",
  "everything-readonly",
];
